import {
  Tab as MuiTab,
  Tabs as MuiTabs,
  type TabProps,
  type TabsProps,
  styled,
  tabClasses,
  tabsClasses,
} from "@mui/material"
import type { SyntheticEvent } from "react"

export interface NavSection {
  id: string
  label: string
}

export interface SectionNavProps {
  sections: NavSection[]
  value: number
  onChange: (event: SyntheticEvent, value: number) => void
  slotProps?: {
    tabs?: Omit<TabsProps, "value" | "onChange" | "children">
    tab?: Omit<TabProps, "label">
  }
}
export const SectionNav = ({
  sections,
  slotProps,
  ...tabsProps
}: SectionNavProps) => (
  <Tabs {...tabsProps} {...slotProps?.tabs}>
    {sections.map(({ label, id }) => (
      <Tab key={id} label={label} {...slotProps?.tab} />
    ))}
  </Tabs>
)

const Tabs = styled(MuiTabs)(({ theme }) => ({
  minHeight: "auto",
  height: "fit-content",
  [`& .${tabsClasses.flexContainer}`]: {
    gap: theme.spacing(3),
  },
  [`& .${tabsClasses.indicator}`]: {
    height: "3px",
  },
}))

const Tab = styled(MuiTab)(({ theme: { palette, typography, spacing } }) => ({
  padding: spacing(1, 1.5),
  fontSize: typography.pxToRem(16),
  minHeight: "auto",
  [`&.${tabClasses.selected}`]: {
    backgroundColor: palette.common.white,
  },
})) as typeof MuiTab
